import * as yup from 'yup';
import {
  GIFT_CARD_PIN_INVALID,
  GIFT_CARD_PIN_REQUIRED,
  RECAPTCHA_REQUIRED,
} from '../../../constants/field-error-messages';
import { GIFT_CARD_PIN_REGEX } from '../../../constants/regex';

export const validationSchema = yup.object().shape({
  pin: yup
    .string()
    .required(GIFT_CARD_PIN_REQUIRED.message)
    .matches(GIFT_CARD_PIN_REGEX, { message: GIFT_CARD_PIN_INVALID.message }),
  recaptcha: yup.string().nullable().required(RECAPTCHA_REQUIRED.message),
});
